module.exports = __webpack_public_path__ + "img/Efdot - Slider 01.c6e0e919.jpg";